import { makeIcon, makeLabel, makeLabelAndIcon } from 'sdi/components/button';
import { TooltipPosition } from 'sdi/components/tooltip';
// import {
//     queryK,
//     dispatchK,
// } from 'sdi/shape';
import tr, { EmptyString } from 'sdi/locale';

// export const { makeIcon, makeLabel, makeLabelAndIcon } = buttonFactory(
//     queryK('component/button'), dispatchK('component/button'));

// const getTableButtonText = () => getLayout() === 'table' ? tr.qa('hideTable') : tr.qa('seeTable');

// export const tableButton = makeIcon('table', 2, 'table');
export const tableButton = makeLabel('table', 1, () => tr.qa('seeTable'));
export const reduceTableButton = makeLabel('table', 1, () =>
    tr.qa('reduceTable')
);

export const defaultTooltip = {
    position: 'bottom-left' as TooltipPosition,
    text: () => EmptyString,
};

export const mapButton = makeIcon(
    'expand',
    2,
    'expand', // 'sncf-expand',
    defaultTooltip
);

export const mapAndTableButton = makeIcon(
    'table',
    2,
    'compress', // 'sncf-compress',
    defaultTooltip
);

export const renderButtonExpand = makeIcon(
    'open',
    3,
    'chevron-down', // 'sncf-chevron-down',
    defaultTooltip
);
export const renderSubButtonExpand = makeIcon(
    'open',
    3,
    'plus', // 'sncf-plus',
    defaultTooltip
);

export const renderButtonCollapse = makeIcon(
    'close',
    3,
    'chevron-up', // 'sncf-chevron-up',
    defaultTooltip
);
export const renderSubButtonCollapse = makeIcon(
    'close',
    3,
    'minus', // 'sncf-minus',
    defaultTooltip
);

export const renderButtonDeselect = makeIcon(
    'close',
    3,
    'times', // 'sncf-time',
    defaultTooltip
);

export const renderButtonEdit = makeLabel('edit', 2, () => tr.core('edit'));
export const renderButtonEditTags = makeLabel('edit', 1, () =>
    tr.qa('editTags')
);

export const renderButtonAddTag = makeLabel('add', 1, () => tr.qa('addTag'));

export const renderButtonDelete = makeIcon(
    'close',
    3,
    'times', // 'sncf-time',
    defaultTooltip
);
export const renderButtonCancelDelete = makeLabel('close', 2, () =>
    tr.core('cancel')
);
export const renderButtonCancelTagDelete = makeLabel('close', 2, () =>
    tr.qa('cancelRemoveTag')
);

export const cancelButton = makeLabel('cancel', 2, () => tr.core('cancel'));
export const saveButton = makeLabel('save', 1, () => tr.core('save'));
export const addButton = makeLabel('add', 1, () => tr.core('add'));

export const renderLinkedIssuesButton = makeLabel('select', 3, () =>
    tr.qa('seeLinkedIssues')
);
export const renderFullTableButton = makeLabelAndIcon(
    'select',
    3,
    'times', // 'sncf-time',
    () => tr.qa('backToFullTable')
);

export const renderButtonAddLinkedIssue = makeLabel('add', 3, () =>
    tr.qa('addLinkedIssue')
);
export const renderButtonAddLinkedGroup = makeLabel('add', 2, () =>
    tr.qa('addLinkedGroup')
);
export const renderButtonDeleteLinkedIssue = makeLabel('edit', 3, () =>
    tr.qa('untieLinkedIssue')
);

// export const renderButtonCancelLinkedFilter = makeLabelAndIcon('clear', 1, 'trash', () => tr.core('resetFilters'));
export const renderAddChangesetButton = makeLabel('add', 3, () =>
    tr.qa('addResolvingChangeset')
);

export const renderBaseLayerButton = makeIcon(
    'select',
    2,
    'map', // 'sncf-layers',
    defaultTooltip
);

export const tableIconButton = makeIcon('table', 3, 'table', defaultTooltip);
